import { useEffect } from 'react';
import { Context } from './Context';
window.dataLayer = window.dataLayer || [];
const isLocal = process.env.APP_ENV === 'local';
/**
 * The GTM script is injected in the index.html by webpack.
 * Here we wait for it to load and then we can push data to it.
 */
export function GtmProvider(props) {
    const { children } = props;
    useEffect(() => {
        if (isLocal)
            return undefined;
        // Check if GTM is already loaded
        if (window.google_tag_manager) {
            window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            return undefined;
        }
        // If not loaded yet, wait for it
        const handleScriptLoad = () => {
            if (window.google_tag_manager) {
                window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            }
        };
        const script = document.querySelector(`script[src*="googletagmanager.com/gtm.js"]`);
        if (script) {
            script.addEventListener('load', handleScriptLoad);
        }
        return () => script === null || script === void 0 ? void 0 : script.removeEventListener('load', handleScriptLoad);
    }, []);
    const push = (data) => {
        if (!data) {
            return;
        }
        Object.entries(data).forEach(([key, value]) => {
            if (value === undefined) {
                // eslint-disable-next-line no-param-reassign
                delete data[key];
            }
        });
        window.dataLayer.push(Object.assign({ pl_data_source: 'app' }, data));
    };
    return <Context.Provider value={{ push }}>{children}</Context.Provider>;
}
